import { buildDboRoute } from 'features/db-optimization/v2/routes';
import { DboNavItem } from 'pages/db-optimization/v2/DbOptimizationControllerV2/types';

import { SidebarItem } from 'main-layout-op/_components/sidebar/SecondarySidebar/_components/SidebarItem';
import {
  getFirstVisibleChild,
  isDboParentRoute,
} from 'pages/db-optimization/v2/DbOptimizationControllerV2/utils';
import { LabelChipV2 } from '@cast/design-system';

export const DboSidebarItem = ({
  item,
  params,
  organizationId,
}: {
  item: DboNavItem;
  organizationId: string;
  params: Record<string, string | number>;
}) => {
  const endAdornment =
    item.badge === 'new' ? (
      <LabelChipV2 label="NEW" color="indigo" size="s" sx={{ ml: 'auto' }} />
    ) : undefined;

  if (isDboParentRoute(item)) {
    const firstChild = getFirstVisibleChild(item);
    if (!firstChild) return null;

    return (
      <SidebarItem
        title={item.title}
        url={buildDboRoute(firstChild.route, params)}
        rulesConditions={{ organizationId }}
        endAdornment={endAdornment}
      >
        {item.children
          .filter(({ routeOnly }) => !routeOnly)
          .map(({ route, title, rules }) => (
            <SidebarItem
              key={route}
              title={title}
              url={buildDboRoute(route, params)}
              rules={rules}
              rulesConditions={{ organizationId }}
            />
          ))}
      </SidebarItem>
    );
  }

  return (
    <SidebarItem
      title={item.title}
      url={buildDboRoute(item.route, params)}
      rules={item.rules}
      rulesConditions={{ organizationId }}
      endAdornment={endAdornment}
    />
  );
};
